import { InputLabel, styled } from '@mui/material';

export const FormLabel = styled(InputLabel, {
  shouldForwardProp: (prop) => prop !== 'highlight',
})<{
  highlight?: 'secondary';
}>(({ theme, highlight }) => ({
  display: 'block',
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.primary,
  ...theme.typography.subtitle2,
  // Default InputLabel disabled color is overridden by the `color` rule
  // above; re-apply it for the `disabled` prop to take effect visually.
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
  },
  ...(highlight === 'secondary' && {
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.secondary.main,
    },
  }),
}));
